// extracted by mini-css-extract-plugin
export var icon = "CustomSearch-mps-module--icon--bc539";
export var root = "CustomSearch-mps-module--root--b9801";